import React, {ChangeEvent, useCallback, useState} from "react";
import { Flex, Text } from "rebass";

import { Section } from "./Section";
import { SwitchCheckbox } from "../../../../../components/styled/SwitchCheckbox";
import { SelectTemplate } from "./SelectTemplate";

const OPTIONS = [
  { value: "50", label: "50 WPM" },
  { value: "100", label: "100 WPM" },
  { value: "150", label: "150 WPM" },
  { value: "200", label: "200 WPM" },
];

export function RampingControl() {
  const [isRamping, setIsRamping] = useState(false);
  const [speed, setSpeed] = useState("100");
  const handleOnChange = useCallback((value: string) => {
    setSpeed(value);
  }, []);
  const setIsRampingCallback = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { target: { checked } } = event;

    setIsRamping(checked);
  }, []);

  return (
    <>
      <Section mt="45px">
        <Flex
          as="label"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text
            color="zodiac"
            fontSize="16px"
            fontWeight={600}
          >
            Automatic Speed Ramping
          </Text>

          <SwitchCheckbox checked={isRamping} />

          <input
            type="checkbox"
            checked={isRamping}
            onChange={setIsRampingCallback}
            hidden
          />
        </Flex>
      </Section>

      <Section
        mt="12px"
        css={`transition: all .4s; opacity: ${isRamping ? "unset" : ".3"};`}
      >
        <SelectTemplate
          title="Speed Ramping"
          value={speed}
          options={OPTIONS}
          handleOnChange={handleOnChange}
          isDisabled={!isRamping}
        />

        <Text
          width={.7}
          color="wild-blue"
          fontSize="14px"
          lineHeight={1.57}
        >
          Automatically increase your listening speed by 5 word per minute every 500-1000 words listened.
        </Text>
      </Section>
    </>
  );
}
